module.exports = __webpack_public_path__ + "static/media/cancel_green.a4554cda.svg";